import React from "react";
import "./styles.less";
import { Button } from "../../components/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CommonConsult } from "../common-consult";

export const MainIndustrySolutions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const data = [
    {
      key: "government",
      title: t("page.industry.item-one.title"),
      img: "//files.authing.co/authing-website/govenment.jpg",
      description: t("page.industry.item-one.descript"),
    },
    {
      key: "publisher",
      title: t("page.industry.item-two.title"),
      img: "//files.authing.co/authing-website/publish.jpg",
      description: t("page.industry.item-two.descript"),
    },
    {
      key: "finance",
      title: t("page.industry.item-tree.title"),
      img: "//files.authing.co/authing-website/finance.jpg",
      description: t("page.industry.item-tree.descript"),
    },
    {
      key: "game",
      title: t("page.industry.item-four.title"),
      img: "//files.authing.co/authing-website/game.jpg",
      description: t("page.industry.item-four.descript"),
    },
  ];

  const gotoDetail = (key) => {
    navigate(`/solutions/${key}`);
  };

  return (
    <div className="industry-solution">
      <div className="inner">
        <div key="1" className="top">
          <div className="headline">{t("page.industry.title")}</div>
          <div className="subline">{t("page.industry.subtitle")}</div>
        </div>

        <div key="2" className="content">
          {data.map((item, index) => (
            <div
              key={index}
              className="item"
              onClick={() => gotoDetail(item.key)}
            >
              <div className="item-image">
                <img src={item.img} alt="" />
              </div>
              <div className="bottom-container">
                <div className="item-title">{item.title}</div>
                <div className="item-text">{item.description}</div>
              </div>
              <p className="view-detail">
                {t("solution.list.hot-solution.common-detial")}
              </p>
            </div>
          ))}
        </div>
        <div key="3" className="button-warp">
          <Button
            style={{ margin: 0, marginRight: 20 }}
            onClick={() => {
              navigate("/solution");
            }}
          >
            {t("common.button.see-more")}
          </Button>
          <CommonConsult
            aside={<Button>{t("common.button.consult")}</Button>}
          />
        </div>
      </div>
    </div>
  );
};
